<template>
    <div class="menu-container" >
        <ul id="menu" class="menu left-menu">
            <template v-for="item in menu">
                <li :key="`menu-item-${item.id}`"
                    class="menu-item"
                    :data-menuid="`${item.id}`"
                    :data-submenu="`${item.menuParent}`"
                    :class="[item.isActive ? 'active' : '', item.menuParent ]">
                    <a v-if="item.forceRegularLink || item.external || isIE10"
                       :href="item.url"
                       class="menu-link"
                       :target="item.forceRegularLink ? '':'_blank'">
                        {{ item.title }}
                    </a>
                    <router-link v-else
                                 class="menu-link"
                                 :to="item.url">
                        {{ item.title }}
                    </router-link>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
    import MenuMixin from './mixin.menu'

    export default {
        name: "HeaderMenu",
        mixins: [ MenuMixin ],
        computed: {
            wpSettings(){
                return wp.settings;
            },
        }
    }
</script>

<style lang="scss" scoped>

    .menu-container{

        .menu{
            list-style: none;
            margin: 0;
            padding: 0;
            display: flex;
            align-items: center;

            li{
                margin-right: 35px;
                a{
                font-weight: 600;
                font-size: 17px;
                text-decoration: none;
                color: $color1;
                transition: all .3s ease-in-out;
                white-space: nowrap;

                    @media (max-width: 1215px){
                        font-size: 15px;
                    }
                }
                @media (max-width: 1299px){
                    margin-right: 15px;
                }

                &.active, &:hover{
                    a{
                        color: $color2;
                    }
                }
            }

            a{
                font-weight: 600;
                font-size: 17px;
                text-decoration: none;
                color: $color1;
                transition: all .3s ease-in-out;
                white-space: nowrap;

                @media (max-width: 1215px){
                    font-size: 15px;
                }
            }
        }
    }

</style>